
export const metricItems = [
    { value: 'Orders', label: 'Orders - Last 7 days' },
    { value: 'Revenue', label: 'Store Revenue - Last 7 days' },
    { value: 'Adspend', label: 'Adspend - Last 7 days' },
    { value: 'MER', label: 'MER - Last 7 days' },
    { value: 'CPO', label: 'CPO - Last 7 days' },
    { value: 'AOV', label: 'AOV - Last 7 days' }
];

export const goalItems = [
    { value: 'Daily', label: 'Daily Goal' },
    { value: 'Previous7', label: 'Previous Week' },
    { value: 'LastMonth', label: 'Last Month' },
    { value: 'LastYear', label: 'Last Year' }
];

export const gradientColors = {
    y1: ['rgba(148, 247, 138, 0.4)', 'rgba(148, 247, 138, 0)'],
    y2: ['rgba(98, 63, 234, 0.4)', 'rgba(98, 63, 234, 0)']
};

export const formatNum = (num, isPrice) => {
    switch (isPrice) {
        case 'even':
            return `${Math.floor(num)}`;
        case false:
            return `${parseFloat(num).toFixed(2)}`;
        default:
            return `${formatCurrency(num)}`;
    }
};

export const formatGoal = (selectedGoal) => {
    if (!selectedGoal) return '';
    switch (selectedGoal.toLowerCase()) {
        case 'daily':
            return 'Daily Goal';
        case 'previous7':
            return 'Previous Week';
        case 'lastmonth':
            return 'This time previous month';
        case 'lastyear':
            return 'This time previous year';
        default:
            return 'Previous AVG';
    }
};

export const getDeltaPercentage = (selectedMetric, avg, goal) => {
    if (!selectedMetric) return 0;
    if (avg == 0 || goal == 0) return 0;

    let ratio;
    if (selectedMetric.toLowerCase() !== 'cpp') {
        ratio = (avg - goal) / goal;
    } else {
        ratio = (goal - avg) / avg;
    }

    return parseFloat(ratio * 100).toFixed(2);
};

// If avg is true, will try to pull average instead of sum, if the name matches (for some client code)
export const getMetricProp = (metric, avg=false) => {
    let p: string = ''
    switch (metric) {
        case 'Purchases':
            p = 'orders';
            break;
        case 'CPO':
            p = 'cpp';
            break;
        default:
            p = metric.toLowerCase();
    }

    if (p && avg && p.indexOf('Avg') < 0) {
        p += 'Avg';
    }

    return p;
};

export const getMetricLongName = (metric) => {
    switch (metric) {
        case 'Revenue':
            return 'Store Revenue';
            break;
        default:
            return metric;
    }
};